
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Line, mixins } from 'vue-chartjs';

@Component
export default class LineBar extends Mixins(Line, mixins.reactiveProp) {
  @Prop({ required: true })
  chartData!: Chart.ChartData;
  @Prop({ required: true })
  chartOptions!: Chart.ChartOptions;
  /** chartDataはreactivePropでリアクティブになるが、chartOptionsの方は対象外なのでWatchで監視し、更新されたら再レンダリングして縦軸・横軸を変化させるようにしている。 */
  @Watch('chartOptions')
  private updateChart(newOptions: Chart.ChartOptions) {
    this.renderChart(this.chartData, newOptions);
  }
  private mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
}
